import {
    FETCH_ACTIVE_PROJECT_LIST,
    FETCH_ACTIVE_PROJECT_MEMBER_LIST,
    FETCH_ACTIVE_PROJECT_AVAILABLE_MEMBER_LIST,
    ADD_MEMBER_TO_ACTIVE_PROJECT,
    REMOVE_MEMBER_FROM_ACTIVE_PROJECT,
    UPDATE_ACTIVE_PROJECT_MEMBER_AUTH,
    UPDATE_PREVIEW_PANEL_INFO
} from '../ActionTypes'

const INITIAL_STATE = {
    activeProjectList: [],
    activeProjectMemberList: {},
    activeProjectAvailableMemberList: [],
    activeProjectPreviewPanelInfo: {},
    isActiveProjectMemberAdding: false,
    isActiveProjectMemberRemoving: false,
    isActiveProjectMemberChangingAuth: false
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_ACTIVE_PROJECT_LIST:
            return {...state, activeProjectList: action.payload }
        // case SELECT_ACTIVE_PROJECT:
        //     return {...state, selectedActiveProjectIdx: action.payload }
        case FETCH_ACTIVE_PROJECT_MEMBER_LIST:
            return {...state, activeProjectMemberList: action.payload }
        case FETCH_ACTIVE_PROJECT_AVAILABLE_MEMBER_LIST:
            return {...state, activeProjectAvailableMemberList: action.payload }
        case UPDATE_PREVIEW_PANEL_INFO:
            return {...state, activeProjectPreviewPanelInfo: action.payload}
        case ADD_MEMBER_TO_ACTIVE_PROJECT:
            return {...state, isActiveProjectMemberAdding: action.payload }
        case REMOVE_MEMBER_FROM_ACTIVE_PROJECT:
            return {...state, isActiveProjectMemberRemoving: action.payload }
        case UPDATE_ACTIVE_PROJECT_MEMBER_AUTH:
            return {...state, isActiveProjectMemberChangingAuth: action.payload }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/ActiveProjectPage/ActiveProjectPageReducer.js